import { render, staticRenderFns } from "./Logout.vue?vue&type=template&id=c9923efc&scoped=true"
import script from "./Logout.vue?vue&type=script&lang=ts"
export * from "./Logout.vue?vue&type=script&lang=ts"
import style0 from "./Logout.vue?vue&type=style&index=0&id=c9923efc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9923efc",
  null
  
)

export default component.exports